import styled from 'styled-components';

import { TargetLink } from '../../targetLink';
import { getUnderLine } from '../../../../theme/mixins';

export const Container = styled(TargetLink)`
  ${getUnderLine('primary')};
`;
